/** CoStar.Api.Analytics.ViewModels.AnalyticsSummary.DataCalculationType */
export var DataCalculationType;
(function (DataCalculationType) {
    DataCalculationType[DataCalculationType["None"] = 0] = "None";
    DataCalculationType[DataCalculationType["Inventory"] = 1] = "Inventory";
    DataCalculationType[DataCalculationType["Deliveries"] = 2] = "Deliveries";
    DataCalculationType[DataCalculationType["UnderConstruction"] = 3] = "UnderConstruction";
    DataCalculationType[DataCalculationType["Absorption"] = 4] = "Absorption";
    DataCalculationType[DataCalculationType["Vacancy"] = 5] = "Vacancy";
    DataCalculationType[DataCalculationType["Rent"] = 6] = "Rent";
})(DataCalculationType || (DataCalculationType = {}));
/** CoStar.Api.Analytics.ViewModels.AnalyticsSummary.DataCalculationTimeframes */
export var DataCalculationTimeframes;
(function (DataCalculationTimeframes) {
    DataCalculationTimeframes[DataCalculationTimeframes["None"] = 0] = "None";
    DataCalculationTimeframes[DataCalculationTimeframes["Current"] = 1] = "Current";
    DataCalculationTimeframes[DataCalculationTimeframes["Last4QuartersPlusCurrent"] = 2] = "Last4QuartersPlusCurrent";
    DataCalculationTimeframes[DataCalculationTimeframes["LastTwelvemonths"] = 3] = "LastTwelvemonths";
})(DataCalculationTimeframes || (DataCalculationTimeframes = {}));
